import store from '../store'
import Cookies from "js-cookie";

export default async (to, from, next) => {

  const cookieToken = Cookies.get('token');
  const storeToken = store.getters['auth/token'];

  if (cookieToken && !storeToken) {
    store.dispatch('auth/saveToken', {token: cookieToken});
  }

  if (!store.getters['auth/check'] && store.getters['auth/token']) {
    try {
        await store.dispatch('auth/fetchUser');
        await store.dispatch('resource/fetchResources');
        await store.dispatch('resource/setDefaultResource');
    }
    catch (err) {
      console.error(err.response.data);
    }
  }

  next();
}
